module.exports = __webpack_public_path__ + "static/media/banking.0dccfafa.jpg";